
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournament",
      function () {
        return require("private-next-pages/tournament.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tournament"])
      });
    }
  